// x-backend's public.currency_rate_provider. Every one but manual is fetched by
// core-cron; a manual source's rates are typed in by hand and cannot be synced.
export const CURRENCY_RATE_PROVIDER = ['manual', 'cbu', 'binance', 'asakabank', 'infinbank'];
